export default __webpack_public_path__ + "static/media/waving.d1aef61d.png";